import { Box, PropertyCard } from '@zillow/constellation-10';

import { useSelector } from '../../../../selectors/useSelector';

import { propertyPhotoStyles } from '../styles';

export const PropertyPhoto = () => {
  const photos = useSelector((state) => state.properties.currentProperty.photos);
  const primaryPhotoUrl = photos.length ? photos[0].url : null;

  return (
    <Box css={{ overflow: 'hidden', ...propertyPhotoStyles }}>
      <PropertyCard.Photo
        src={primaryPhotoUrl ?? undefined}
        alt="property"
        fallbackImg={<PropertyCard.PhotoFallback />}
        css={{ width: '100%', height: '104px' }}
      />
    </Box>
  );
};
